import type { DefaultTheme } from 'styled-components';
import styled, { css } from 'styled-components';
import { IconChevronLeft } from '@prisjakt/ui/icon/chevron-left';
import { IconChevronRight } from '@prisjakt/ui/icon/chevron-right';
import {
  ButtonElevation,
  ButtonType,
  IconButton,
} from '@prisjakt/ui/button/variants';
import { media, layout } from 'src/components/base';

export const ArrowIconRight = styled(IconChevronRight).attrs(() => ({
  color: 'base300',
}))``;

export const ArrowIconLeft = styled(IconChevronLeft).attrs(() => ({
  color: 'base300',
}))``;

interface IHorizontalScrollProps {
  negativeMargin?: boolean;
}

export const HorizontalScrollContainer = styled.div<IHorizontalScrollProps>`
  height: 100%;
  width: inherit;
  position: relative;

  ${p =>
    // Values have to match page padding :/
    p.negativeMargin &&
    media.smallOnly`
      left: -${layout.measurements.spacing050};
      width: 100vw;

      ul > li:first-child {
        padding-left: ${layout.measurements.spacing050};
      }

      ul > li:last-child {
        padding-right: ${layout.measurements.spacing050};
      }
    `}
`;

const arrow = (theme: DefaultTheme) => css`
  background: ${theme.colors.base0};
  &:hover {
    background: ${theme.colors.base100};
  }
  z-index: 2;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  opacity: 0;
  transition: all 250ms ease;

  ${media.smallOnly`
    display: none;
  `}
`;

const arrowButtonAttrs = {
  elevation: ButtonElevation.HIGH,
  type: ButtonType.OUTLINED,
};

export const LeftArrow = styled(IconButton).attrs(arrowButtonAttrs)`
  ${p => arrow(p.theme)}
  left: ${layout.measurements.spacing075};
`;

export const RightArrow = styled(IconButton).attrs(arrowButtonAttrs)`
  ${p => arrow(p.theme)}
  right: ${layout.measurements.spacing075};
`;

export const Inner = styled.div`
  -ms-overflow-style: none;
  -webkit-overflow-scrolling: touch;
  overflow: -moz-scrollbars-none;
  &::-webkit-scrollbar {
    display: none;
  }

  user-select: none;

  width: inherit;
  overflow-x: scroll;

  &:hover {
    > button {
      opacity: 1;
    }
  }
`;

export const List = styled.ul`
  list-style: none;
  margin: 0;
  display: flex;

  > li {
    padding: 1px;
    padding-bottom: ${layout.measurements.spacing050};
  }

  > li:not(:first-child) {
    margin-left: 12px;
  }
`;

export const Loader = styled.li`
  float: left;
  width: 100px;
  text-align: center;
`;
